import { useEffect, useState } from 'react';
import Color from '../Color/Color';
import IndexSelector from '../IndexSelector/IndexSelector';
import { MaterialSelector } from '../MaterialSelector/MaterialSelector';
import { Parameters } from '../Parameters/Parameters';
import SingleMaterial from '../SingleMaterial/SingleMaterial';
import { useMaterialSliders } from './Materials.hooks';
import { Params, Top, Wrapper } from './Materials.style';

export type MaterialsProps = {
  materialPack: IMaterialPack;
  materials: IMaterial[];
  slotId: SlotId;
  slotConfig: ISlotConfig;
  onSlotChange: (slotId: SlotId) => void;
  onChange: (change: Json) => void;
  onSet: (change: Json) => void;
  onLibraryClick: (pack: IMaterial) => void;
};

export function Materials(props: MaterialsProps) {
  const { materialPack, slotConfig, slotId, materials } = props;
  const [index, setIndex] = useState<SlotId>(slotId);
  const material = materialPack[index];
  const { id, tint } = material ?? {};
  const data = useMaterialSliders(material);

  useEffect(() => {
    setIndex(slotId);
  }, [slotId]);

  function onLibraryClick(value: IMaterial) {
    props.onLibraryClick(value);
  }

  function onSlotChange(value: SlotId) {
    setIndex(value);
    props.onSlotChange(value);
  }

  function onChangeColor(value: string) {
    props.onChange({ tint: value });
    props.onSet({ tint: value });
  }

  function onSet(id: string, value: string | number | boolean) {
    props.onChange({ [id]: value });
    props.onSet({ [id]: value });
  }

  function onChange(id: string, value: string | number | boolean, isSilent?: boolean) {
    props.onChange({ [id]: value });
  }

  function onRemove() {
    props.onChange({ textureId: '', texture: {} });
  }

  return (
    <Wrapper className='Materials-wrapper' data-testid='Materials-wrapper'>
      <Top>
        <IndexSelector total={4} value={index} slotConfig={slotConfig} onChange={onSlotChange} />
      </Top>
      <SingleMaterial material={material} onRemove={onRemove} />
      <Params className='params'>
        <Parameters id={id} data={data} onSet={onSet} onChange={onChange}>
          <Color value={tint} onChange={onChangeColor} />
        </Parameters>
      </Params>
      <MaterialSelector value={materials[index]} materials={materials} onSelect={onLibraryClick} />
    </Wrapper>
  );
}

/*


*/

export default Materials;
